import React from 'react';
import Form from '../../forms/form';
import Box from '../../containers/box';
import Icon from '../../icon';
import Immutable from 'immutable';
import Button from '../../forms/button';
import Centerer from '../../containers/centerer';
import {ErrorList} from '../../../data/validation';
import styled from 'styled-components';

const EMPTY_LIST = Immutable.List([]);
const EMPTY_MAP = Immutable.Map({});

export default function ItemRepeaterDefinition(content) {
	if (!(this instanceof ItemRepeaterDefinition)) {
		return new ItemRepeaterDefinition(content);
	}

	const me = this;
	content._parentDefinition = this;
	content.setOffline(true);
	let path = [];
	let readOnly;
	let emptyValue = null;
	let isReadOnlyCallback;
	let width;
	let minWidth;
	let label;
	let noError;

	content.onChange((ctx, item, value) => {
		const index = ctx.getBasePathLeaf();
		ctx = ctx.withShortenedBasePath(1);
		let list = (ctx.getData() || EMPTY_LIST);
		if (value) {
			if (list.indexOf(value) < 0) {
				list = list.push(value);
				ctx.setData(list);
			}
		} else {
			ctx.setData(list.delete(index));
		}
	});

	this.getError = function(ctx) {
		return ctx.getError(path);
	};


	this.setNoError = function(value) {
		noError = value;
		return this;
	};

	this.getNoError = function() {
		return noError;
	};


	this.hasLabel = function() {
		return label !== null && label !== undefined;
	}

	this.setLabel = function(value) {
		label = value;
		return this;
	};

	this.getLabel = function(ctx) {
		return label ?? name;
	};


	this.setWidth = function(value) {
		width = value;
		return this;
	};

	this.setMinWidth = function(value) {
		minWidth = value;
		return this;
	};

	this.getWidth = function() {
		return width;
	};

	this.getMinWidth = function() {
		return minWidth;
	};

	const isReadOnly = function(ctx) {
		return readOnly || (isReadOnlyCallback && isReadOnlyCallback(ctx));
	};

	this.setEmptyValue = function(value) {
		emptyValue = value;
		return this;
	};

	this.setPath = function(value) {
		if (typeof value === 'string') {
			value = [ value ];
		}
		path = value || [];
		return this;
	};

	this.setReadOnly = function(value) {
		if (typeof value === 'function') {
			readOnly = false;
			isReadOnlyCallback = value;
		} else {
			readOnly = !!value;
			isReadOnlyCallback = null;
		}
		return this;
	};

	const renderItem = function(ctx, index) {
		ctx = ctx.withAppendedBasePath(index);
		return (
			<Item key={index} width={content.getWidth()}>
				{content.renderInput(ctx)}
			</Item>
		);
	};

	this.validateAll = function(ctx, errors) {
	};


	this.render = function(ctx, key = 0) {
		ctx = ctx.withAppendedBasePath(path);
		let values = (ctx.getData() || EMPTY_LIST);
		const readOnly = isReadOnly(ctx);
		if (!readOnly) {
			values = values.push(emptyValue);
		}
		return (
			<ItemRepeater key={key}>
				{
					values.map((value, index) => renderItem(ctx, index))
				}
			</ItemRepeater>
		)
	};

	this.renderInput = this.render;

}

const ItemRepeater = styled.span`
	display: block;
	position: relative;
	text-align: left;
`;

const Item = styled.span`
	display: inline-block;
	position: relative;
	vertical-align: middle;
	width: ${props => props.width};
`;